
import { Message } from 'element-ui';
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { addSupplier, updateSupplier, getSupplierDetail } from '@/api/pcm/supplier';
import { wait } from '@/utils/wait';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
        form: {},
        isEdit: false
	},
	actions: {
		async afterOpenDialog({ dispatch, commit, state }) {
			const { id, isEdit } = state;
			if (isEdit) {
				await wait(dispatch, 'pcm.supplier.addedit', async function() {
					const response = await getSupplierDetail(id);
					commit('save', {
						form: {
							...response.data,
							suppPlatform: Number(response.data.suppPlatform)
						}
					})
				})
			}
		},
		async confirm({ dispatch, commit, state }) {
			const { id, form, isEdit } = state;
			await wait(dispatch, 'pcm.supplier.confirm', async function() {
				if (isEdit) {
					await updateSupplier(id, form);
				} else {
					await addSupplier(form);
				}
				Message.success('操作成功');
				dispatch('closeDialog');
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/supplier/add-edit-dialog.js